import { useCallback } from 'react'

export const useDeleteSound = (soundEnabled: boolean) => {
  const playDeleteSound = useCallback(() => {
    if (!soundEnabled) return

    try {
      const audioContext = new (
        window.AudioContext ||
        (window as unknown as { webkitAudioContext: typeof AudioContext })
          .webkitAudioContext
      )()
      const oscillator = audioContext.createOscillator()
      const gainNode = audioContext.createGain()

      oscillator.connect(gainNode)
      gainNode.connect(audioContext.destination)

      oscillator.frequency.setValueAtTime(392.0, audioContext.currentTime)
      oscillator.frequency.setValueAtTime(
        261.63,
        audioContext.currentTime + 0.1
      )

      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
      gainNode.gain.exponentialRampToValueAtTime(
        0.01,
        audioContext.currentTime + 0.3
      )

      oscillator.start(audioContext.currentTime)
      oscillator.stop(audioContext.currentTime + 0.3)
    } catch (error) {
      console.error('Failed to play delete sound:', error)
    }
  }, [soundEnabled])

  return { playDeleteSound }
}
